// TODO Needs a discussion with backend, no endpoint
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import * as Bananas from "bananas-commerce-admin";

import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Divider,
  Stack,
  Switch,
  Typography,
  useTheme,
} from "@mui/material";

import { useSnackbar } from "notistack";

import { IndividualRuleSchema } from "../../types";
import { GAP, GRID_FOUR_COLUMNS } from "../../utils";

import DeadlinesSection from "./DeadlinesSection";
import ExclusionsSection from "./ExclusionsSection";
import InclusionsSection from "./InclusionsSection";

export interface CustomScheduleCardProps {
  defaultExpanded?: boolean;
}

const CustomScheduleCard: React.FC<CustomScheduleCardProps> = ({}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [rule, setRule] = useState<IndividualRuleSchema>();
  const { abbreviation } = useParams();
  const theme = useTheme();
  const { enqueueSnackbar } = useSnackbar();
  const api = Bananas.useApi();

  const saveRule = async () => {
    if (rule == null) return;

    const filteredRule = {
      ...rule,
      inclusions: rule.inclusions.filter(
        (inclusion) => inclusion.day_name && inclusion.date,
      ),
      exclusions: rule.exclusions.filter(
        (exclusion) => exclusion.day_name && exclusion.date,
      ),
      times_exceptions: rule.times_exceptions.filter(
        (exception) => exception.for_date && exception.deadline_date,
      ),
    };

    const operation = api.operations["mediahouse.individual:edit"];
    if (operation == null) {
      enqueueSnackbar("Kunde inte hitta API-operationen", { variant: "error" });
      return;
    }
    const response = await operation.call({
      params: { abbreviation },
      body: filteredRule,
    });

    if (!response?.ok) {
      enqueueSnackbar("Kunde inte spara schemat", { variant: "error" });
      return;
    }
    enqueueSnackbar("Schemat har sparats", { variant: "success" });
    setRule(filteredRule);
    setIsEditing(false);
  };

  useEffect(() => {
    if (rule != null) return;

    const fetchRule = async () => {
      const operation = api.operations["mediahouse.individual:get"];

      const response = await operation?.call({
        params: {
          abbreviation,
        },
      });

      if (!response?.ok) {
        enqueueSnackbar("Kunde inte hämta schemat", { variant: "error" });
        return;
      }
      const rule: IndividualRuleSchema = await response.json();

      setRule(rule);
    };
    fetchRule();
  }, []);

  return (
    <Card
      sx={{
        borderRadius: 2,
      }}
      variant="outlined"
    >
      <CardContent sx={{ p: 0, pb: "0 !important" }}>
        <Stack
          alignItems="center"
          borderBottom={1}
          borderColor="divider"
          direction="row"
          justifyContent="space-between"
          p={2}
        >
          <Typography fontWeight={500} variant="body1">
            Titelanpassat utgivningsschema
          </Typography>

          <Switch
            checked={isEditing}
            onChange={() => setIsEditing(!isEditing)}
          />
        </Stack>

        <Box>
          <Box
            sx={{
              bgcolor: theme.palette.mode === "dark" ? "grey.900" : "grey.50",
              display: "grid",
              py: GAP,
              px: GAP * 1.25,
              gap: GAP,
            }}
          >
            <InclusionsSection
              gap={GAP}
              gridTemplateColumns={GRID_FOUR_COLUMNS}
              isEditing={isEditing}
              rule={rule}
              onRuleChange={setRule}
            />
            <Divider />
            <ExclusionsSection
              gap={GAP}
              gridTemplateColumns={GRID_FOUR_COLUMNS}
              isEditing={isEditing}
              rule={rule}
              onRuleChange={setRule}
            />
            <Divider />
            <DeadlinesSection
              gap={GAP}
              gridTemplateColumns={GRID_FOUR_COLUMNS}
              isEditing={isEditing}
              rule={rule}
              onRuleChange={setRule}
            />
          </Box>
        </Box>
      </CardContent>
      {isEditing && (
        <CardActions sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Button onClick={saveRule}>Spara</Button>
        </CardActions>
      )}
    </Card>
  );
};

export default CustomScheduleCard;
